module.exports = __webpack_public_path__ + "static/media/organized.01c0df10.png";